<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important" v-permission="'eon_create_with_label.index'">
            <v-card class="px-0 size">
                <v-card-text>
                    <v-row align="center" justify="center" class="pt-3 mt-3 text-center">
                        <v-col cols="6" align="center" justify="center">    
                            <h2 class="blue_accent--text text-uppercase">{{ $t('fulfillment_eon_new_with_label.new') }}</h2>
                        </v-col>
                    </v-row>
                    <v-row class="px-0 pt-0 pb-2 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0">
                            <label style="font-size: 15px; font-weight: bold;" class="blue_accent--text">{{$t('fulfillment_eon_new_with_label.general_data')}}</label>
                        </v-col>
                    </v-row>

                    <v-form ref="form">
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <client-selector :addAllOption="false" ref="clientSelector" @getClients="v => items.clients = v" :is_national="2"></client-selector>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-autocomplete class="mt-0 py-0" v-model="external_shipment_with_label.channel_sale" item-text="text" item-value="value" :items="channels" :rules="rules_required" :label="$t('fulfillment_eon_new_with_label.channel_sale')"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.unique_order_number" :label="$t('fulfillment_eon_new_with_label.order_number')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.name" :label="$t('fulfillment_eon_new_with_label.buyers_name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.postal_code" :label="$t('fulfillment_eon_new_with_label.postal_code')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.neighborhood" :label="$t('fulfillment_eon_new_with_label.neighborhood')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.street_line" :label="$t('fulfillment_eon_new_with_label.address')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.state" :label="$t('fulfillment_eon_new_with_label.state')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.municipality" :label="$t('fulfillment_eon_new_with_label.municipality')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.phone" :label="$t('fulfillment_eon_new_with_label.phone')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.consignee.comments" :label="$t('fulfillment_eon_new_with_label.comments')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0 my-0">
                                <v-text-field class="py-0" v-model="external_shipment_with_label.total_price" :label="$t('fulfillment_eon_new_with_label.total_price')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row class="px-0 pt-0 pb-2 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0">
                            <label style="font-size: 15px; font-weight: bold;" class="blue_accent--text">{{$t('fulfillment_eon_new_with_label.products')}}</label>
                        </v-col>
                    </v-row>

                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="2" class="py-0 my-0">
                            <v-autocomplete class="mt-0 py-0" :loading="products_load" v-model="product.id" item-text="sku" item-value="id" :items="products" :label="$t('fulfillment_eon_new_with_label.select_product')"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" class="py-0 my-0 mx-0 px-0">
                            <v-text-field class="py-0" v-model="product.quantity" :label="$t('fulfillment_eon_new_with_label.quantity')"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="py-0 my-0 mx-0 px-1">
                            <v-text-field class="py-0" v-model="product.unit_price" :label="$t('fulfillment_eon_new_with_label.unit_price')"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0 my-0 mx-0 px-0" justify="end" align="end">
                            <v-btn color="secondary" outlined @click="addProduct()">
                                {{ $t('fulfillment_eon_new_with_label.add') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0 px-4" justify="center" align="center">
                        <v-col cols="6" class="py-0 my-0 mx-0 px-0">
                            <datatable :ff_quantity_editable="true" :hide_pagination="true" class="custom_table_class" :props="{headers:productsHeaders, items: current_products}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>

                    <v-row class="px-0 pt-0 pb-2 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0">
                            <label style="font-size: 15px; font-weight: bold;" class="blue_accent--text">{{$t('fulfillment_eon_new_with_label.boxes')}}</label>
                        </v-col>
                    </v-row>

                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="3" class="py-0 my-0">
                            <v-autocomplete class="mt-0 py-0" :loading="boxes_load" v-model="box.id" item-text="name" item-value="id" :items="boxes" :label="$t('fulfillment_eon_new_with_label.select_box')"></v-autocomplete>
                        </v-col>
                        <v-col cols="3" class="py-0 my-0 mx-0 px-0">
                            <v-text-field class="py-0" v-model="box.quantity" :label="$t('fulfillment_eon_new_with_label.quantity')"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0 my-0 mx-0 px-0" justify="end" align="end">
                            <v-btn color="secondary" outlined @click="addBox()">
                                {{ $t('fulfillment_eon_new_with_label.add') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0 px-4" justify="center" align="center">
                        <v-col cols="6" class="py-0 my-0 mx-0 px-0">
                            <datatable :ff_quantity_editable="true" :hide_pagination="true" class="custom_table_class" :props="{headers:boxesHeaders, items: external_shipment_with_label.boxes}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>

                    <v-row class="px-0 py-0 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0 my-0 mx-0 px-0" align="end" justify="end">
                            <v-btn class="mx-3" text @click="cancel()">{{ $t('fulfillments_prepaid_returns.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="saveOrder()">
                                {{ $t('fulfillment_eon_new_with_label.save') }}
                            </v-btn>    
                        </v-col>
                    </v-row>
                </v-card-text> 
            </v-card>
        </v-container>   
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
    import { createExternalShipmentWithLabelUseCase } from "../application/use_cases/create_external_shipment_with_label_use_case";
    import { HttpExternalShipmentRepository } from "../infrastructure/external_shipment_repository";
    import { getStateAndCityUseCase } from '../../shared/application/use_cases/get_state_and_city_use_case';
    import { HttpAddressLocationsRepository } from "../../shared/infrastructure/repositories/address_locations_repository";
    import { getClientProductsUseCase } from "../../products/application/use_cases/get_client_products_use_case";
    import { HttpProductRepository } from '../../products/infrastructure/product_repository';
    import { boxIndexUseCase } from "../../boxes/application/use_cases/box_index_use_case";
    import { HttpBoxRepository } from "../../boxes/infrastructure/box_repository";

    export default {
        computed: {
            productsHeaders(){
                return [
                    { text: this.$t('fulfillment_eon_new_with_label.sku'), value: 'sku', width: '50%' },
                    { text: this.$t('fulfillment_eon_new_with_label.quantity'), value: 'quantity', width: '20%' },
                    { text: this.$t('fulfillment_eon_new_with_label.unit_price'), value: 'unit_price', width: '20%' },
                    { text: '', value: 'actions', class: 'text-uppercase', width:'10%' }
                ];
            },  
            boxesHeaders(){
                return [
                    { text: this.$t('fulfillment_eon_new_with_label.name'), value: 'name', width: '60%' },
                    { text: this.$t('fulfillment_eon_new_with_label.quantity'), value: 'quantity', width: '30%' },
                    { text: '', value: 'actions', class: 'text-uppercase', width:'10%' }
                ];
            },  
            rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
            numeric_required(){
                return [
                    v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                    v => !!v || this.$t('edit_appointment.validations.required_field')
                ];
            },
        },
        mounted(){
            this.loadData();
            this.$store.state.module = "headers.fulfillment_eon_new_with_label";
        },
        data(){
            return {
                snackbar: {
                    visible: false,
                    color: 'primary',
                    text: ''
                },
                channels: this.$store.state.channels,
                external_shipment_with_label: {
                    client_id: 1,
                    channel_sale: "",
                    unique_order_number: "",
                    total_price: "",
                    consignee: {
                        name: "",
                        country: "México",
                        state: "",
                        municipality: "",
                        neighborhood: "",
                        street_line: "",
                        postal_code: "",
                        phone: "",
                        comments: ""
                    },
                    products: [],
                    kits: [],
                    boxes: []
                },
                actions_p: [
                    {
                        name: this.$t('edit_shipment.delete_product'),
                        icon: {
                            color: 'error',
                            icon: 'disabled_by_default'
                        },
                        method: 'deleteProduct',
                    }
                ],
                actions_b: [
                    {
                        name: this.$t('edit_shipment.delete_box'),
                        icon: {
                            color: 'error',
                            icon: 'disabled_by_default'
                        },
                        method: 'deleteBox',
                    }
                ],
                products_load: false,
                boxes_load: false,
                products: [],
                product: {},
                boxes: [],
                current_products: [],
                current_boxes: [],
                box: {}
            };
        },
        methods: {
            async loadData(){
                this.boxes = [];
                this.boxes_load = true;

                try {
                    const res = await boxIndexUseCase(HttpBoxRepository);
                    this.boxes = res;
                } catch(e){
                    console.log(e.response);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.fault.message
                    }
                }
                
                this.boxes_load = false;
            },
            methodHandler(object){
                this[object.methodName](object.parameters)
            },
            async saveOrder(){
                try {
                    this.current_products.forEach(x => {
                        const c_product = {
                            id: parseInt(x.id.split("_")[1]),
                            quantity: parseInt(x.quantity),
                            unit_price: parseFloat(x.unit_price)
                        };

                        if(x.id.split("_")[0] == "k") this.shipment.kits.push(c_product);
                        else this.external_shipment_with_label.products.push(c_product);
                    })

                    this.external_shipment_with_label.boxes.forEach(x => {
                        delete x.actions;
                        delete x.parameters;
                    })

                    const response = await createExternalShipmentWithLabelUseCase(this.external_shipment_with_label, HttpExternalShipmentRepository);
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: JSON.stringify(response)
                    }
                    
                    this.$router.go(-1);  

                } catch (e) {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e
                    }
                }
            },
            addProduct(){
                const product = {
                    sku: this.products.find(x => x.id == this.product.id).sku,
                    quantity: this.product.quantity,
                    id: this.product.id,
                    unit_price: this.product.unit_price,
                    actions: JSON.parse(JSON.stringify(this.actions_p)),
                    parameters: this.product.id
                }  

                this.current_products.push(product);
                this.product.sku = "";
                this.product.id = "";
                this.product.quantity = "";
                this.product.unit_price = "";
            },  
            addBox(){
                var c_box = this.boxes.find(x => x.id == this.box.id);

                const box = {
                    name: c_box.name,
                    quantity: this.box.quantity,
                    id: this.box.id,
                    weight: c_box.volumetricWeight,
                    actions: JSON.parse(JSON.stringify(this.actions_b)),
                    parameters: this.box.id
                }  

                this.external_shipment_with_label.boxes.push(box);
                this.box.name = "";
                this.box.id = "";
                this.box.quantity = "";
            },
            cancel(){
                this.$router.go(-1);  
            }
        },
        watch:{
            '$store.state.clientId': async function (){
                this.products = [];
                this.products_load = true;
                this.external_shipment_with_label.client_id = this.$store.state.clientId;

                const response = await getClientProductsUseCase(this.$store.state.clientId, HttpProductRepository);
                this.products = response;
                
                this.products_load = false;
            },
            'external_shipment_with_label.consignee.postal_code': async function(){
                this.external_shipment_with_label.consignee.state = '';
                this.external_shipment_with_label.consignee.municipality = '';
    
                if(this.external_shipment_with_label.consignee.postal_code.length == 5){
                    const response = await getStateAndCityUseCase({
                        zipcode: this.external_shipment_with_label.consignee.postal_code, 
                        state: "", 
                        city: "" }, HttpAddressLocationsRepository);
    
                    this.external_shipment_with_label.consignee.state = response.state;
                    this.external_shipment_with_label.consignee.municipality = response.city;
                }
            }
        }
    }
</script>